import React, { useEffect } from "react";
import axios from "axios";
import whiteLogo from "../../images/whiteLogo.png";
import "../../styles/loginSignup.css";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import mbimg from "../../images/image5.png";
import Loader from "../../containers/Loader";
import config from "../../config/config";
import Settings from "../settings.json";

const LoginSignupComponent = (props) => {
  const redirectToSubs = () => props.history.push("/subscription");

  const dispatch = useDispatch();
  const logInResponse = useSelector((state) => state.loginReducer);
  const [hasAccess, setAccess] = React.useState("pending");

  const openLoginModal = (e) => {
    e.preventDefault();
    dispatch({ type: "LOGIN_MODAL_OPEN" });
  };

  useEffect(() => {
    if (logInResponse.isLoggedIn && hasAccess === "pending") {
      checkAccess(props.history.location.redirectFrom);
    } else if (logInResponse.isLoggedIn && hasAccess) {
      window.history.back();
    }
  }, [logInResponse, hasAccess]);

  const checkAccess = (topicId) => {
    let url = config.BASE_URL + Settings.loadTopicRenderingUrl;
    let userEmail = logInResponse.isLoggedIn ? logInResponse.email : "null";
    let urlToHit = url.replace("id", topicId);

    axios
      .get(urlToHit, {
        params: {
          email: userEmail,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setAccess(response.data.response.hasAccess);
        }
      });
  };

  return (
    <>
      {logInResponse.isLoggedIn && hasAccess === "pending" ? (
        <Loader />
      ) : (
        <div className="login-signup-wrapper">
          <div className="nav">
            <div className="tablet-back">
              <i className="fa fa-angle-left" aria-hidden="true"></i>
            </div>
            <div className="logo">
              <Link to="/">
                <img alt="vet-logo" src={whiteLogo} />
              </Link>
            </div>
          </div>
          <div className="content">
            <h1 className="content-heading">
              A veterinary gut check in your pocket.
            </h1>
            <div className="content-blue-line"></div>
            <h3 className="content-sub-heading">
              BY BLACKWELL’S 5 MINUTE CONSULT SERIES
            </h3>
            <p className="content-para">
              The topic you're trying to access is not free.
            </p>
            <div className="med-screen-img">
              <img alt="vet-about" src={mbimg} />
            </div>
            {logInResponse.isLoggedIn && hasAccess === false ? (
              <>
                <p className="content-para">Please subscribe to the topic.</p>
                <Link to="/subscription">
                  <button className="button subs-button">
                    View Subscriptions
                  </button>
                </Link>
              </>
            ) : (
              <>
                <div className="button-pair">
                  <button
                    className="button signup-button"
                    onClick={redirectToSubs}
                  >
                    Subscribe Now
                  </button>
                  <button
                    className="button login-button"
                    onClick={openLoginModal}
                  >
                    Log in
                  </button>
                </div>
              </>
            )}
            <Link to="/">
              <p className="content-para">
                Go to Home <i className="fa fa-home" aria-hidden="true"></i>
              </p>
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default LoginSignupComponent;
